import React, { Component } from "react";
export default class LanguageNamingSection extends Component {
  render() {
    var {
      language_naming_picture_name_1,
      language_naming_picture_status_1,
      language_naming_picture_name_2,
      language_naming_picture_status_2,
      language_naming_picture_name_3,
      language_naming_picture_status_3,
      language_naming_picture_name_4,
      language_naming_picture_status_4,
      language_naming_picture_name_5,
      language_naming_picture_status_5,
      language_naming_picture_name_6,
      language_naming_picture_status_6,
      language_naming_picture_name_7,
      language_naming_picture_status_7,
      language_naming_picture_name_8,
      language_naming_picture_status_8,
      written_picture_score,
      language_naming_score
    } = this.props.data;
    return (
      <div className="row p-0 border border-dark bg-white">
        <div className="col-lg-12 p-3">
          <span className="fs-19">
            <div className="row" style={{ fontSize: 15 }}>
              <div className="col-lg-6 d-flex">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    1)
                  </p>
                  <img
                    className="form-picture"
                    src={
                      "./assets/images/ecas/form-b/language_naming/1.png"
                    }
                    alt="Peacock"
                    style={{ width: 170,maxWidth:170 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="language_naming_picture_name_1"
                      value={language_naming_picture_name_1}
                      type="text"
                      className="ecas-input-field"
                    />
                  </div>
                </div>
                <br />
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    2)
                  </p>
                  <img
                    className="form-picture"
                    src={
                      "./assets/images/ecas/form-b/language_naming/2.png"
                    }
                    alt="Jacket"
                    style={{ width: 170,maxWidth:170 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="language_naming_picture_name_2"
                      type="text"
                      className="ecas-input-field"
                      value={language_naming_picture_name_2}
                    />                      </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    3)
                  </p>
                  <img
                    className="form-picture"
                    src={
                      "./assets/images/ecas/form-b/language_naming/3.png"
                    }
                    alt="Tractor"
                    style={{ width: 170,maxWidth:170 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="language_naming_picture_name_3"
                      type="text"
                      className="ecas-input-field"
                      value={language_naming_picture_name_3}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    4)
                  </p>
                  <img
                    className="form-picture"
                    src={
                      "./assets/images/ecas/form-b/language_naming/4.png"
                    }
                    alt="Zebra"
                    style={{ width: 170,maxWidth:170 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="language_naming_picture_name_4"
                      type="text"
                      className="ecas-input-field"
                      value={language_naming_picture_name_4}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    5)
                  </p>
                  <img
                    className="form-picture"
                    src={
                      "./assets/images/ecas/form-b/language_naming/5.png"
                    }
                    alt="Wrench"
                    style={{ width: 170,maxWidth:170 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="language_naming_picture_name_5"
                      type="text"
                      className="ecas-input-field"
                      value={language_naming_picture_name_5}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    6)
                  </p>
                  <img
                    className="form-picture"
                    src={
                      "./assets/images/ecas/form-b/language_naming/6.png"
                    }
                    alt="Hedgehog"
                    style={{ width: 170,maxWidth:170 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="language_naming_picture_name_6"
                      type="text"
                      className="ecas-input-field"
                      value={language_naming_picture_name_6}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    7)
                  </p>
                  <img
                    className="form-picture"
                    src={
                      "./assets/images/ecas/form-b/language_naming/7.png"
                    }
                    alt="Owl"
                    style={{ width: 170,maxWidth:170 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="language_naming_picture_name_7"
                      type="text"
                      className="ecas-input-field"
                      value={language_naming_picture_name_7}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    8)
                  </p>
                  <img
                    className="form-picture"
                    src={
                      "./assets/images/ecas/form-b/language_naming/8.png"
                    }
                    alt="Tambourine"
                    style={{ width: 170,maxWidth:170 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 210 }}
                      name="language_naming_picture_name_8"
                      value={language_naming_picture_name_8}
                      type="text"
                      className="ecas-input-field"
                    />
                  </div>
                </div>
              </div>
            </div>
          </span>
          <hr />
          <div className="col-lg-6">
            <span className="fs-19">Score (0-8) </span>
            <input
              type="number"
              value={written_picture_score}
              name="language_naming_score"
              readOnly
              className="ecas-input-field"
            />
          </div>
        </div>
      </div>
    );
  }
}
